import cn from 'classnames';
import './CarModelDetailsPrevNextButtons.scss';
import React from 'react';
import Prev from '../../../../Icons/Prev';
import Next from '../../../..//Icons/Next';

export default function CarModelPrevNextButtons({ isOpen, onPrev, onNext }) {
  return (
    <div className={'car-model-details-prev-next-button'}>
      <button className={cn('button', 'button_prev', isOpen && 'button_show')} onClick={onPrev}>
        <Prev />
      </button>
      <button className={cn('button', 'button_next', isOpen && 'button_show')} onClick={onNext}>
        <Next />
      </button>
    </div>
  );
}
